import { render, staticRenderFns } from "./reports-company.vue?vue&type=template&id=374ad91b&"
import script from "./reports-company.vue?vue&type=script&lang=js&"
export * from "./reports-company.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports